import { Injectable } from '@angular/core';
import { EntityCollectionServiceBase, EntityCollectionServiceElementsFactory } from '@ngrx/data';
import { County } from '../../../model/county';

@Injectable({
    providedIn: 'root'
})
export class CountyEntityService extends EntityCollectionServiceBase<County> {
    constructor(serviceElementsFactory: EntityCollectionServiceElementsFactory) {
        super('County', serviceElementsFactory);
    }
}
